<div class="flex flex-column dashboard-page">
    <div class="flex flex-column">
        <h4
            class="m-0 date-line"
            >{{ currentDate | date: 'MMMM d, y':'UTC' }}</h4
        >

        <div class="flex flex-row align-items-center justify-content-between">
            <span class="welcome-line-1">
                Welcome, {{ (currentUser$ | async)?.firstName }}
                <img
                    class="m-0"
                    ngSrc="/assets/icons/welcome.svg"
                    height="30"
                    width="30"
                    alt="Welcome" />
            </span>

            <div
                class="flex-row align-items-center quick-actions-container gap-20px">
                <ng-container *ngTemplateOutlet="quickActions"></ng-container>
            </div>
        </div>

        <span class="welcome-line-2">{{ currentQuote }}</span>
    </div>

    <div class="quick-actions-container-mobile flex-column mb-3">
        <ng-container *ngTemplateOutlet="quickActions"></ng-container>
    </div>

    @if ((isTrialAccount$ | async) && !isAsap && showQuickStart) {
        <div class="flex flex-column gap-3 mb-3">
            <app-quick-start-banner
                [isAdminOrOwner]="(isAdmin$ | async) ?? false"
                (hidden)="showQuickStart=false">
            </app-quick-start-banner>
        </div>
    }

    @if ((isOwner$ | async) && (isAsap) && showUpgradeBanner) {
        <div
            class="border-round p-3 relative md:p-5"
            style="background-color: var(--bg-promotional-alert);">
            <p-button
                class="absolute top-0 right-0 m-2"
                [style.z-index]="'10'"
                [text]="true"
                (click)="dismissUpgradeBanner()"
                ariaLabel="Dismiss upgrade banner">
                <i class="pi pi-times"></i>
            </p-button>

            <div
                class="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-3 p-3 md:p-0">
                <div class="flex flex-column gap-2">
                    <h1 class="m-0 line-height-2 text-xl">
                        Unlock the Full Power of Your ASAP Reports
                    </h1>
                    <p class="m-0 text-sm">
                        Submitting reports is just the first step. With our SMS
                        Essentials plan, you can take action, dig into root
                        cause analysis, assign corrective actions, and track
                        safety tasks directly in the Safety Assurance module.
                    </p>
                </div>

                <p-button
                    class="hidden md:inline-flex"
                    (click)="goToUpgrade()"
                    styleClass="w-max"
                    label="Upgrade Your Plan">
                </p-button>

                <p-button
                    class="md:hidden w-full block"
                    (click)="goToUpgrade()"
                    styleClass="w-full block"
                    label="Upgrade Your Plan">
                </p-button>
            </div>
        </div>
    }
    <div class="content-container mt-5">
        <div class="flex flex-column gap-20px w-full">
            <div class="flex justify-content-between">
                @if (isAsap) {
                    <h2 class="m-0">Your Active Reports</h2>
                } @else {
                    <h2 class="m-0">{{ assignedItemsTitle }}</h2>
                }
            </div>

            <div class="flex justify-content-between">
                <ng-container>
                    <form
                        [formGroup]="filterForm"
                        class="flex flex-row justify-content-between align-items-center w-full gap-2">
                        <div class="flex flex-row gap-2 align-items-center">
                                <div formGroupName="dateRange">
                                    <app-home-date-filter
                                        [filterForm]="filterForm.get('dateRange')"
                                        (filterApplied)="onFilterApplied($event)">
                                    </app-home-date-filter>
                                </div>
                            @if (!isAsap) {
                                <p-dropdown
                                    styleClass="dropdown-rounded"
                                    [autoDisplayFirst]="false"
                                    formControlName="formType"
                                    [options]="formType"
                                    [placeholder]="'All Types'">
                                </p-dropdown>
                            }
                        </div>

                        @if ((isAdmin$ | async) && !isAsap) {
                            <div class="scope-toggle" role="group">
                                <button
                                    type="button"
                                    class="scope-option"
                                    [class.selected]="currentScope === 'mine'"
                                    (click)="setScope('mine')">
                                    {{ scopeMineLabel }}
                                </button>
                                <button
                                    type="button"
                                    class="scope-option"
                                    [class.selected]="currentScope === 'everyone'"
                                    (click)="setScope('everyone')">
                                    {{ scopeEveryoneLabel }}
                                </button>
                            </div>
                        }
                    </form>
                </ng-container>
            </div>
            @if (hasPastDueItems && !isPastDueFilter()) {
                <p-messages
                    severity="warn"
                    styleClass="message-warning">
                    <ng-template pTemplate>
                        <div class="flex align-items-center w-full">
                            <img
                                class="m-0"
                                src="/assets/icons/warn.svg"
                                alt="Overdue Tasks" />

                            <div
                                class="flex flex-wrap justify-content-between align-items-center pl-2 flex-grow-1 gap-2 py-3">
                                <p class="font-bold m-0"
                                    >You have past due items to address.</p
                                >

                                <p-button
                                    text="true"
                                    label="View Past Due"
                                    styleClass="p-0"
                                    (click)="loadPastDueTasks()">
                                </p-button>
                            </div>
                        </div>
                    </ng-template>
                </p-messages>
            }
            <div>
                <router-outlet></router-outlet>
            </div>
        </div>

        <div class="flex flex-column gap-3 w-full">
            <!-- Promotional Card (ACSF for ASAP account owners, Manual Promo for non-ASAP accounts) -->
            @if (showPromotionalCard && (isOwner$ | async) && (isAsap || isAviationAccount)) {
                <app-promotional-card
                    [cardType]="isAsap ? 'acsf' : 'manual'"
                    (hidden)="showPromotionalCard=false">
                </app-promotional-card>
            }
            @if (!isAsap) {
                <app-ask-rise
                    *featureFlag="'riseAgent'"
                    class="w-full"
                    [scope]="(isAdmin$ | async) ? 'account' : 'mine'">
                </app-ask-rise>
                @if (isAdmin$ | async) {
                    <app-program-health
                        class="w-full"
                        (filterChange)="onHealthFilterChange($event)">
                    </app-program-health>
                } @else {
                    <app-performance-panel
                        class="w-full"
                        [scope]="'mine'"
                        [compact]="true">
                    </app-performance-panel>
                }
            }
            @if (isAsap && (asapFormId$ | async)) {
                <app-home-asap-performance
                    class="w-full"
                    [isAdmin]="isAdmin$ | async"
                    [asapFormId]="(asapFormId$ | async)">
                </app-home-asap-performance>
            }
        </div>
    </div>

    <!--
      Full width beneath the two columns, because it reads left to right and a
      pipeline squeezed into a column is not a pipeline. Admins only: it
      reports on the account rather than on the person looking at it.
    -->
    @if ((isAdmin$ | async) && !isAsap) {
        <app-safety-pipeline class="w-full"></app-safety-pipeline>
        <!--
          Last on the page: what needs me, then where work is stuck, then
          whether we are keeping up.
        -->
        <app-performance-panel class="w-full"></app-performance-panel>
    }
</div>

<ng-template #quickActions>
    <p-button
        styleClass="py-2 w-full lg:w-auto"
        severity="secondary"
        (click)="createTask()"
        label="Create Task" />
    <p-button
        styleClass="py-2 w-full lg:w-auto"
        (click)="submitReport()"
        label="Submit Report" />
</ng-template>

@if (reportSidebarVisible) {
    <app-flight-report-details
        [visible]="true"
        [assessmentId]="reportSidebarAssessmentId"
        [mode]="'create'"
        [returnTo]="returnToUrl"
        (closed)="reportSidebarVisible = false">
    </app-flight-report-details>
}
